module.exports = __webpack_public_path__ + "static/media/teamTwo.0809a59b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/team/teamTwo.jpg
// module id = 97
// module chunks = 0